<template>
  <div class="submit-process-layer">
    <div class="submit-process">
      <img src="/static/images/bsl_icon.png" />
      <span>AI努力批改中{{ process }}%</span>
      <el-progress
        :show-text="false"
        :stroke-width="24"
        :percentage="process"
        color="#24cc7c"
      ></el-progress>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: '',
  data() {
    return {
      duration: 5000,
      process: 0,
      resolve: () => {},
      reject: () => {},
    }
  },
  methods: {
    close() {
      clearInterval(this.time)
      if (this.process > 98) {
        this.process = 100
        setTimeout(() => {
          this.$el.parentElement.removeChild(this.$el)
          this.resolve()
        }, 30)
      } else {
        // 剩余在1.5秒内跑完
        let item = ((100 - this.process) / 1500) * 100
        const old = this.process
        let index = 0
        this.time = setInterval(() => {
          index++
          this.process = old + Math.round(index * item)
          if (this.process > 99) {
            setTimeout(() => {
              this.$el.parentElement.removeChild(this.$el)
              this.resolve()
            }, 30)
            clearInterval(this.time)
          }
        }, 100)
      }
    },
  },
  mounted() {
    let item = (100 / this.duration) * 100
    let index = 0
    this.time = setInterval(() => {
      index++
      let next = Math.round(index * item)
      if (next >= 98) {
        this.process = 98
        clearInterval(this.time)
      } else {
        this.process = next
      }
    }, 100)
  },
}
</script>
  
  <style lang="less" scoped>
.submit-process-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
.submit-process {
  width: 386px;
  height: 139px;
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.08);
  background: #fff;
  padding: 0 38px;
  position: fixed;
  top: 50%;
  left: 40%;
}
span {
  font-size: 16px;
  color: #9e9e9e;
  line-height: 48px;
  text-align: center;
  display: block;
  margin-top: 42px;
}
img {
  position: absolute;
  top: -100px;
  left: 33%;
  width: 170px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Stu/StuPractice/StuExam/submitProcess/app.vue